import { all, call, fork, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE, GET_PROFILE } from "./actionTypes"
import { editProfileFlag, profileError, profileSuccess } from "./actions"

//Include Both Helper File with needed methods
import { toast } from "react-toastify"
import {
  editProfileData,
  getProfileData,
} from "../../../helpers/fakebackend_helper"
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import { userNewPasswordError } from "../newpwd/actions"

const fireBaseBackend = getFirebaseBackend()

function* getProfile({ payload: { user } }) {
  if (!user) return
  try {
    const response = yield call(getProfileData, user)
    yield put(profileSuccess(response.data))
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong"
    if (
      errorMessage === "Invalid Token" ||
      errorMessage === "Invalid session"
    ) {
      console.log("errorMessage", errorMessage)
      toast.error(errorMessage + "Please re-login")
      localStorage.removeItem("authUser")
      localStorage.removeItem("token")
      window.location.href = "/login"
    }
    console.log("error", errorMessage)
    yield put(userNewPasswordError(error))
  }
}

function* editProfile({ payload: { user, values } }) {
  try {
    const response = yield call(editProfileData, { user, values })
    toast.success(response.message)
    yield put(profileSuccess(response.data))
    yield put(editProfileFlag(true))
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong"

    console.log("error", error)
    if (
      errorMessage === "Invalid Token" ||
      errorMessage === "Invalid session"
    ) {
      console.log("errorMessage", errorMessage)
      toast.error(errorMessage + "Please re-login")
      localStorage.removeItem("authUser")
      localStorage.removeItem("token")
      window.location.href = "/login"
    }
    toast.error(errorMessage)
    yield put(profileError(error))
  }
}
export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(GET_PROFILE, getProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
